import { DecisionAction } from "shared/types/application";

export enum Views {
  MakeDecision = "MakeDecision",
  Conditions = "Conditions",
  ResidencyConditions = "ResidencyConditions",
  DecisionSettings = "DecisionSettings",
  Email = "Email",
  Success = "Success"
}

export type FormData = {
  decision?: DecisionAction;
  decisionNotes: string;
  unlistUnit: boolean;
  sendNotifications: boolean;
  addApplicantsToPMS: boolean;
  conditions: string[];
  residencyConditions?: string[];
  additionalCondition: string;
  additionalResidencyCondition: string;
  additionalEmailText: string;
  increasedMonthlyRent: string;
};

export type FlowConfig = {
  [K in DecisionAction]: Views[];
};

export type FormDataErrors = Partial<Record<keyof FormData, string>>;
